module.exports = __webpack_public_path__ + "crm_static/img/image@2x.bea3f56c.png";